<template>
    <div>
        <d-contract-mnt-edit
            v-model      = "edit"
            :contract-id = "contract ? contract.id : null"
            :company-id  = "contract && contract.company ? contract.company.id : null"
            @saved       = "onSaved"
        />

        <c-list-card
            :icon       = "icon"
            :background = "background"
            :height     = "166"
            :edit       = "editable"
            :border     = "border"
            :border-width = "borderWidth"
            @edit       = "onEdit"
            @selected   = "onSelect"
        >
            <template v-slot:title>
                <div class="card-title">
                    {{ contract.id }} - {{ contract.contracttype ? contract.contracttype.name : '' }}
                </div>
                <v-spacer></v-spacer>
                <company-tag
                    v-if       = "showLabels"
                    :label     = "$t('msd.service.role.mnt.label')"
                    :active    = "contract.active"
                    :company   = "contract.company"
                    :highlight = "company && contract.company.id === company.id"
                />
                <company-tag
                    v-if="contract.service && showLabels"
                    :label     = "$t('msd.service.role.srv.label')"
                    :active    = "contract.active"
                    :company   = "contract.service"
                    :highlight = "company && contract.service.id === company.id"
                />
                <company-tag
                    v-if       = "contract.prmRole && showLabels"
                    :label     = "$t('msd.service.role.adm.label')"
                    :active    = "contract.active"
                    :highlight = "company && contract.prmRole.id === company.id"
                    :company   = "contract.prmRole"
                />
            </template>

            <template v-slot:subtitle>
                <div class="primary--text customer-name">
                    {{ contract.customer ? contract.customer.name : '' }}
                </div>
            </template>

            <template v-slot:body>
                <v-row class="no-frame card-subtitle mt-1">
                    <v-col class="no-frame col-12 flex-panel pl-0" >
                        <c-tag
                            class="flex-tag"
                            :label="$t('contract.mnt.rentIncluded')"
                            :active="contract.rentIncluded"
                        />
                        <c-tag
                            class="flex-tag"
                            :label="$t('contract.mnt.standByIncluded')"
                            :active="contract.standByIncluded"
                        />
                        <c-tag
                            class="flex-tag"
                            :label="$t('contract.mnt.teleserviceIncluded')"
                            :active="contract.teleserviceIncluded"
                        />
                        <c-tag
                            class="flex-tag"
                            :label="$t('contract.mnt.inspectionIncluded')"
                            :active="contract.inspectionIncluded"
                        />
                        <c-tag
                            class="flex-tag"
                            :label="$t('contract.mnt.phoneIncluded')"
                            :active="contract.phoneIncluded"
                        />
                        <c-tag
                            class="flex-tag"
                            :label="$t('contract.mnt.guardIncluded')"
                            :active="contract.guardIncluded"
                        />
                        <c-tag
                            class="flex-tag"
                            :label="$t('contract.mnt.smokeextractionIncluded')"
                            :active="contract.smokeextractionIncluded"
                        />
                        <c-tag
                            class="flex-tag"
                            :label="$t('contract.mnt.inspectioAddOnIncluded')"
                            :active="contract.inspectioAddOnIncluded"
                        />
                        <c-tag
                            class="flex-tag"
                            :label="$t('contract.mnt.incidentIncluded')"
                            :active="contract.incidentsIncluded"
                        />
                    </v-col>
                </v-row>
                <p-contract-condition
                    class="mt-2"
                    :contract = "contract"
                />
             </template>
        </c-list-card>
    </div>
</template>

<script>

import Core             from "@/modules/core/service/Core";
import CListCard        from "@/modules/core/components/utils/CListCard";
import CTag             from "@/modules/core/components/utils/CTag";
import CompanyTag       from "@/modules/msd/company/common/components/controlls/CompanyTag";
import DContractMntEdit from "@/modules/msd/company/contract/components/controls/mnt/DContractMntEdit";
import PContractCondition from "@/modules/msd/company/contract/components/controls/common/PContractCondition.vue";

export default {
    name: "CContractMntCard",
    components: {
        PContractCondition,
        DContractMntEdit,
        CompanyTag,
        CTag,
        CListCard,
    },

    props: {
        contract: {

        },

        background: {
            required: false,
            type    : String,
            default : function () {
                return null;
            }
        },

        company: {

        },

        editable: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        border: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        borderWidth: {
            required: false,
            type    : String,
            default : function () {
                return "pa-3";
            }
        },

        showLabels: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        }
    },

    data: () => ({
        edit: false,
        tagwidth: 90,
    }),

    computed: {
        icon () {
            return {
                label : "W",
                active: this.contract.active,
            }
        },
    },

    methods: {
        onSelect () {
            Core.fire.selected(this, this.contract);
        },

        onEdit () {
            this.edit = true;
        },

        onSaved (contract) {
            Core.fire.saved(this, contract);
        },

        toHtml (text) {
            return Core.format.html(text);
        },

        money (value) {
            return Core.format.money(value);
        },

        date (value) {
            return Core.format.date.sdisplay(value);
        },
    }
}
</script>

<style scoped>

.contract-disabled {
    cursor: none !important;
    pointer-events: none;
}

.card-title {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.card-subtitle {
    font-size: 13px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

::v-deep .v-card--link:focus:before {
    opacity: 0.0!important;
}

.flex-panel {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: flex-start;
    height: 44px;
}

.flex-tag {
    width: calc(20% - 4px);
    max-width: calc(20% - 4px);
    min-width: calc(20% - 4px);
    margin-left: 0!important;
    margin-right: 4px;
}

.tag {
    flex-grow: 1;
    width: 100%;
    margin-left: 4px;
}

</style>